module.exports = __webpack_public_path__ + "img/2025-10-15b_2.7efac81d.jpg";